import cn from 'classnames';
import { UiText, UiTitle } from 'znanie-uikit';

import Cover from 'components/common/Cover';

import css from './SpeakerAdvancedCard.module.scss';

interface IProps {
  fullName: string;
  photoUrl: string;
  description?: string;
  className?: string;
}

export default function SpeakerAdvancedCard({
  fullName,
  description,
  photoUrl,
  className = '',
}: IProps) {
  return (
    <Cover
      className={cn(css.card, className)}
      background={photoUrl}
      imgProxyProps={{
        sourceWidth: 688,
        sourceHeight: 800,
        resizingType: 'fill',
        gravityType: 'ce',
      }}
    >
      <UiTitle className={css.title} color="white" as="h3">
        {fullName}
      </UiTitle>
      {description && (
        <UiText
          truncateProps={{ clamp: 3, useNativeClamp: true }}
          className={css.description}
        >
          <div>{description}</div>
        </UiText>
      )}
    </Cover>
  );
}
